// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__N1sxF","vLegacy":"SelectSecondary_vLegacy__3p5z_","error":"SelectSecondary_error__2OSjV","disabled":"SelectSecondary_disabled__2boSN"};